import { createGlobalStyle } from 'styled-components';
import {
  font,
  gutter,
  delay,
  zindex
} from '@/views/styles/variables';

const GlobalStyle = createGlobalStyle`
  *, ::after, ::before {
    line-height: normal;
    box-sizing: border-box;
    line-height: normal;
  }

  html {
    font-family: "IBM Plex Sans Thai", sans-serif;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    overflow-x: hidden;
  }

  body{
    font-family: ${font.family.default};
    font-size: ${font.size.default};
    color: ${({ theme }: any) => theme.font.color.default};
    background: ${({ theme }: any) => theme.colors.background.secondary};
    font-weight: ${font.weight.normal};
    line-height: 1.43;
    margin: 0px;
    max-width: 100%;
    overflow-x: hidden;
    &.lock{
      width: 100%;
      height: 100vh;
      overflow: hidden;
    }
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  body::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  body {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }

  audio,
  canvas,
  progress,
  video {
    display: inline-block;
    vertical-align: baseline;
  }

  audio:not([controls]) {
    display: none;
    height: 0;
  }

  [hidden],
  template {
    display: none;
  }

  a{
    text-decoration: none;
    background-color: transparent;
    cursor: pointer;
    &:active,
    &:hover {
      outline: 0;
    }
  }

  abbr[title] {
    border-bottom: 1px dotted;
  }

  b,
  strong {
    font-weight: ${font.weight.semibold};
  }

  dfn {
    font-style: italic;
  }

  small {
    font-size: 80%;
  }

  img {
    border: 0;
  }

  svg:not(:root) {
    overflow: hidden;
  }

  figure {
    margin: 1em 40px;
  }

  hr {
    box-sizing: content-box;
    height: 0;
    margin-block-start: ${gutter.default};
    margin-block-end: ${gutter.default};
  }

  pre {
    overflow: auto;
  }

  code,
  kbd,
  pre,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    color: inherit;
    font: inherit;
    margin: 0;
  }

  button {
    overflow: visible;
    font-weight: ${font.weight.semibold};
  }

  button,
  select {
    text-transform: none;
  }

  button,
  html input[type="button"],
  input[type="reset"],
  input[type="submit"] {
    -webkit-appearance: button;
    cursor: pointer;
  }

  button[disabled],
  html input[disabled] {
    cursor: not-allowed;
  }

  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  input {
    line-height: normal;
    outline: none;
  }

  input[type="checkbox"],
  input[type="radio"] {
    box-sizing: border-box;
    padding: 0;
    outline: none !important;
    border: none ;
  }

  input[type="checkbox"] {
    width: 22px;
    height: 22px;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    height: auto;
    -webkit-appearance: none; 
    -moz-appearance:textfield;
    -ms-appearance: none; 
    -o-appearance: none; 
    margin: 0; 
  }


  input[type="search"] {
    -webkit-appearance: textfield;
    box-sizing: content-box;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    border-radius: 4px;
    margin-right: 2px;
    opacity: 0.6;
    /* filter: invert(0.8); */
  }

  input[type="date"]::-webkit-calendar-picker-indicator:hover {
    opacity: 1
  }

  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  fieldset {
    border: 1px solid #c0c0c0;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }

  legend {
    border: 0;
    padding: 0;
  }

  textarea {
    overflow: auto;
  }

  optgroup {
    font-weight: ${font.weight.semibold};
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  thead{
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
  }
  
  td,
  th {
    padding: 0;
  }

  h1, h2, h3, h4, h5, h6{
    font-weight: ${font.weight.semibold};
  }

  a{
    color: ${({ theme }: any) => theme.link.color};
    text-decoration: ${({ theme }: any) => theme.link.decoration};
  }

  .toast-top-left {
    top: 80px !important;
    left: 12px;
  }
  .toast-top-right {
    top: 80px !important;
    right: 12px;
  }

  .toast {
    background-color: #030303;
  }
  .toast-success {
    background-color: ${({ theme }: any) => theme.colors.success.default} !important;
  }
  .toast-error {
    background-color: ${({ theme }: any) => theme.colors.danger.default}  !important;
  }
  .toast-info {
    background-color: ${({ theme }: any) => theme.colors.secondary.default}  !important;
  }
  .toast-warning {
    background-color: ${({ theme }: any) => theme.colors.warning.default}  !important;
  }

  #toast-container > div{
    box-shadow: none !important;
  }

  .swal2-container{
    z-index: 3172 !important;
  }

  .react-datepicker-wrapper{
    width: 100%;
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected{
    background-color: ${({ theme }: any) => theme.colors.primary.default};
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
      border-radius: 0.3rem;
      background-color: ${({ theme }: any) => theme.colors.primary.default};
      color: #fff;
    }
    .react-datepicker__input-container{
      width: 100%;
      input{
        display: block;
        height: 48px;
        width: 100%;
        background-color: ${({ theme }: any) => theme.input.default.background};
        border: 2px;
        border-radius: 0px;
        padding: ${gutter.small} ${gutter.default};
        transition: ${delay};
        &:focus{
          outline: none;
          box-shadow: 0 0 0 0.2rem rgba(156,4,5,.25);
        }
        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: ${({ theme }: any) => theme.font.color.light};
          opacity: 1; /* Firefox */
        }
    
        :-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: ${({ theme }: any) => theme.font.color.light};
        }
    
        ::-ms-input-placeholder { /* Microsoft Edge */
          color: ${({ theme }: any) => theme.font.color.light};
        }
      }
    }

  /* Make clicks pass-through */
  #nprogress {
    pointer-events: none;
  }

  #nprogress .bar {
    background: #29d;

    position: fixed;
    z-index: ${zindex.modal};
    top: 0;
    left: 0;

    width: 100%;
    height: 2px;
  }

  /* Fancy blur effect */
  #nprogress .peg {
    display: block;
    position: absolute;
    right: 0px;
    width: 100px;
    height: 100%;
    box-shadow: 0 0 10px #29d, 0 0 5px #29d;
    opacity: 1;

    -webkit-transform: rotate(3deg) translate(0px, -4px);
    -ms-transform: rotate(3deg) translate(0px, -4px);
    transform: rotate(3deg) translate(0px, -4px);
  }

  /* Remove these to get rid of the spinner */
  #nprogress .spinner {
    display: block;
    position: fixed;
    z-index: ${zindex.modal};
    top: 15px;
    right: 15px;
  }

  #nprogress .spinner-icon {
    width: 18px;
    height: 18px;
    box-sizing: border-box;

    border: solid 2px transparent;
    border-top-color: ${({ theme }: any) => theme.colors.primary.default};
    border-left-color: ${({ theme }: any) => theme.colors.primary.default};
    border-radius: 50%;

    -webkit-animation: nprogress-spinner 400ms linear infinite;
    animation: nprogress-spinner 400ms linear infinite;
  }

  #nprogress .bar {
    height: 4px;
    background: ${({ theme }: any) => theme.colors.primary.default};
  }

  .nprogress-custom-parent {
    overflow: hidden;
    position: relative;
  }

  .nprogress-custom-parent #nprogress .spinner,
  .nprogress-custom-parent #nprogress .bar {
    position: absolute;
  }

  @-webkit-keyframes nprogress-spinner {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes nprogress-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .swal2-container{
    z-index: 3172 !important;
    button {
      display: inline-block;
      padding: ${gutter.small} ${gutter.default};;
      /* height: 44px; */
      font-size: ${font.size.default};
      line-height: 1.5;
      border: none;
      border-radius: .25rem;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      outline: none;
      &:disabled{
        cursor: not-allowed;
        box-shadow: none;
        opacity: .5;
      }

      &.swal2-confirm {
        background: ${({ theme }) => theme.colors.primary.default};
        /* color: ${({ theme }) => theme.colors.primary.contrastText}; */
        color: #fff;

        &:active{
          opacity: 0.7;
          background-color: ${({ theme }) => theme.colors.primary.focus};
        }
      }

      &.swal2-cancel {
        background: ${({ theme }) => theme.colors.danger.default};
        color: ${({ theme }) => theme.colors.danger.contrastText};

        &:active{
          opacity: 0.7;
          background-color: ${({ theme }) => theme.colors.danger.focus};
        }
      }
    }
  }
  .swal2-styled{
    min-width: 100px;
  }
  .swal2-popup{
    background: #fff;
    color: #000;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 2px #949494;
    padding-top: ${gutter.default};
  }

  .swal2-styled{
    min-width: 120px;
    &.swal2-confirm{
      background-color: ${({ theme }) => theme.colors.primary.default} !important;
      color: ${({ theme }) => theme.colors.primary.contrastText} !important;
    }
  }

  .swal2-title{
    font-size: 1.5em;
    padding: 0.6em;

    /* background: linear-gradient(to bottom,#2f68d5,#284eaa,#1d3682,#0f205b,#040938); */
    background: #fff;
    color: #000;
  }
  .swal2-html-container{
    font-size: ${font.size.default};
  }

  .swal2-icon{
    margin-top: 1em;
    order: 2;
    &.swal2-error{
      border-color: ${({ theme }) => theme.colors.danger.default};
      color: ${({ theme }) => theme.colors.danger.default};
      [class^=swal2-x-mark-line]{
        background: ${({ theme }) => theme.colors.danger.default};
      }
    }
    &.swal2-info{
      border-color: ${({ theme }) => theme.colors.secondary.default};
      color: ${({ theme }) => theme.colors.secondary.default};
    }
    &.swal2-warning{
      border-color: ${({ theme }) => theme.colors.warning.default};
      color: ${({ theme }) => theme.colors.warning.default};
    }
    &.swal2-success{
      border-color: ${({ theme }) => theme.colors.success.default};
      color: ${({ theme }) => theme.colors.success.default};
      .swal2-success-line-tip,
      .swal2-success-line-long,
      .swal2-success-fix{
        background: ${({ theme }) => theme.colors.success.default};
      }
      
    }
  }

  #swal2-title{
    order: 1;
  }
  #swal2-html-container {
    order: 2;
  }
  .swal2-actions{
    order: 3;
    gap: 10px;
  }

  a {
    color: #000;
  }

  .withCursor {
    cursor: pointer;
  }

  .rdt_Table {
    background: none;
  }

  .LazyLoad {
    opacity: 0;
    transition: all 1s ease-in-out;
  }
  
  .is-visible {
    opacity: 1;
  }
`;

export default GlobalStyle;
